import { render, staticRenderFns } from "./PromoOfferLocation.vue?vue&type=template&id=71e28960&"
import script from "./PromoOfferLocation.vue?vue&type=script&lang=js&"
export * from "./PromoOfferLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports